import Vue from 'vue'

Vue.config.devtools = true

import App from './App.vue'
import router from './router'
import store from './store'
import moment from 'moment'

import JWT from '@/mixins/JWT.js'

import '@/vendor/jquery.min.js'
import '@/vendor/bootstrap/js/dist/util.js'
import '@/vendor/bootstrap/js/dist/modal.js'

//Vue.config.productionTip = false

Vue.filter('formatDate', function(value) {
    if (!value) {
        return ''
    }
    return moment.unix(value).format('MMM Do YYYY HH:mm');
})

Vue.filter('formatStatus', function(value) {
    switch (value) {
        case 0:
            return "Invalid"
        case 1:
            return "Access only"
        case 2:
            return "In use"
        default:
            return `Unknown (${value})`
    }
})

Vue.filter('ellipsize', function(value, maxLen) {
    if (!value) {
        return value
    }
    if (value.length > maxLen) {
        return value.slice(0, maxLen) + "..."
    }
    return value
})

new Vue({
    router,
    store,
    render: h => h(App),
    mixins: {
        parseAuthToken: JWT.parseAuthToken
    }
}).$mount('#app')
